import React from "react";
import "./footer.scss";
import { MENU_ITEMS_LEFT, MENU_ITEMS_RIGHT } from "../header/Header";
import { useNavigate } from "react-router-dom";
import { MOBILE_BUSINESS_HOURS, orderedDays, SALON_BUSINESS_HOURS } from "../../constants/businessHours";
import { valueToString } from "../../Helpers";
import { DateTime } from "luxon";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faPhone } from "@fortawesome/free-solid-svg-icons";
import { SOCIALS } from "../../constants/socials";
import { useBusinessHours } from "../../context/businessHoursContext";

export default function Footer() {
  const navigate = useNavigate();
  const businessHours = useBusinessHours();

  function handleNavigate(url: string, newTab = false) {
    if (newTab) {
      window.open(url, "_blank");
    } else {
      navigate(url);
    }
  }

  return (
    <footer>
      <div className="footer-info-container">
        <div>
          <div className="footer-logo-container">
            <img className="footer-logo" alt="Comfort Cutz Logo" src="images/logo.webp" />
          </div>
          <div className="footer-hours-container">
            {businessHours && businessHours?.length > 0 ? (
              businessHours?.map((location, index) => {
                return (
                  <div className="footer-inner-container" key={index}>
                    <p className="footer-primary-text">{location?.title} Hours</p>
                    {orderedDays?.map(day => {
                      const open = DateTime.fromFormat(location?.hours[day]?.open, "hh:mm")?.toFormat("h a");
                      const closed = DateTime.fromFormat(location?.hours[day]?.close, "hh:mm")?.toFormat("h a");
                      const timeRange = location?.hours[day]?.closed ? "Closed" : `${open} - ${closed}`;
                      return (
                        <p key={day} className="footer-tertiary-text">
                          {valueToString(day)}: {timeRange}
                        </p>
                      );
                    })}
                  </div>
                );
              })
            ) : (
              <>
                <div className="footer-inner-container">
                  <p className="footer-primary-text">Salon Hours</p>
                  {Object.keys(SALON_BUSINESS_HOURS)?.map((dayOfWeek, index) => {
                    const day = SALON_BUSINESS_HOURS[dayOfWeek];
                    const open = DateTime.fromFormat(day?.open, "hh:mm")?.toFormat("h a");
                    const closed = DateTime.fromFormat(day?.close, "hh:mm")?.toFormat("h a");
                    const timeRange = day?.closed ? "Closed" : `${open} - ${closed}`;
                    return (
                      <p key={index} className="footer-tertiary-text">
                        {valueToString(dayOfWeek)}: {timeRange}
                      </p>
                    );
                  })}
                </div>
                <div className="footer-inner-container">
                  <p className="footer-primary-text">Mobile Service Hours</p>
                  {Object.keys(MOBILE_BUSINESS_HOURS)?.map((dayOfWeek, index) => {
                    const day = MOBILE_BUSINESS_HOURS[dayOfWeek];
                    const open = DateTime.fromFormat(day?.open, "hh:mm")?.toFormat("h a");
                    const closed = DateTime.fromFormat(day?.close, "hh:mm")?.toFormat("h a");
                    const timeRange = day?.closed ? "Closed" : `${open} - ${closed}`;
                    return (
                      <p key={index} className="footer-tertiary-text">
                        {valueToString(dayOfWeek)}: {timeRange}
                      </p>
                    );
                  })}
                </div>
              </>
            )}
          </div>
          <br />
          <div className="footer-inner-container">
            <p className="footer-secondary-text">1651 Erbs Rd.</p>
            <p className="footer-secondary-text">St. Agatha, Ontario</p>
            <p className="footer-secondary-text">N0B 2L0</p>
            <br />
            <a href="mailto:comfortcutzmobilesalon@gmail.com" className="footer-secondary-text footer-link">
              <FontAwesomeIcon icon={faEnvelope} /> comfortcutzmobilesalon@gmail.com
            </a>
            <a href="tel:519-496-1246" className="footer-secondary-text footer-link">
              <FontAwesomeIcon icon={faPhone} /> +1 519-496-1246
            </a>
          </div>
        </div>
      </div>
      {/* <hr className="footer-divider" /> */}
      <div className="footer-bottom-menu">
        <div className="footer-bottom-menu-copyright-group">
          <p className="footer-bottom-menu-text">© {new Date().getFullYear()} Comfort Cutz. All rights reserved</p>
          <div className="footer-bottom-menu-socials-group">
            {SOCIALS?.map((social, index) => (
              <div
                key={index}
                className="footer-bottom-menu-socials-container"
                onClick={() => handleNavigate(social.url, true)}
              >
                <FontAwesomeIcon fixedWidth className="footer-bottom-menu-socials" icon={social.icon} />
              </div>
            ))}
          </div>
        </div>

        <div className="footer-bottom-menu-options">
          {MENU_ITEMS_LEFT?.filter(item => !item?.subOptions)?.map((item, index) => (
            <p
              key={index}
              className="footer-bottom-menu-text footer-bottom-menu-text-link"
              onClick={() => handleNavigate(item.url)}
            >
              {item.label}
            </p>
          ))}
          {[...MENU_ITEMS_RIGHT, { label: "Join Our Team", url: "/careers" }, { label: "Reviews", url: "/reviews" }]
            ?.filter(item => !item?.subOptions)
            ?.map((item, index) => (
              <p
                key={index}
                className="footer-bottom-menu-text footer-bottom-menu-text-link"
                onClick={() => handleNavigate(item.url)}
              >
                {item.label}
              </p>
            ))}
        </div>
      </div>
    </footer>
  );
}
